import React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  MenuItem,
  Select,
} from "@mui/material";

export default function SimDetails({
  formData,
  handleInputChange,
  RequiredLabel,
  StandardLabel,
  errors = {},
  t,
  isEditMode,
}) {
  // console.log(formData)
  return (
    <Box
      sx={{
        padding: { xs: "0px 20px", md: "0px 40px" },
        margin: { xs: "0px 20px", md: "0px 40px" },
        backgroundColor: isEditMode ? "#E8EAEE" : "#FFFFFF",
        // border: '1px solid #A5DCF3',
        borderRadius: "10px",
        // boxShadow: '-2px 2px 5px 0px #00000040',
        // mb: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Paper
          sx={{
            height: 52,
            width: "100%",
            borderRadius: "8px",
            padding: "12px 24px",
            backgroundColor: "#647490",
            boxShadow: "-2px 2px 5px 0px #00000040",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{ fontSize: { xs: "18px", md: "20px" } }}
          >
            {t("SIM Card Details")}
          </Typography>
        </Paper>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} mb={1}>
                <StandardLabel label={t("SIM Number / MSISDN")} />
                <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: false }}
                  placeholder={t("Type SIM Number")}
                  value={formData.simCard?.mobileNumber || ""}
                  onChange={(e) => handleInputChange(e, "simCard.mobileNumber")}
                  error={!!errors.mobileNumber}
                  helperText={errors.mobileNumber}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "55px",
                      borderRadius: "16px",
                      padding: "16px 24px",
                      border: errors.mobileNumber
                        ? "2px solid #d32f2f"
                        : "2px solid #183059",
                      "&:hover": {
                        border: errors.mobileNumber
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "&.Mui-focused": {
                        border: errors.mobileNumber
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "& fieldset": {
                        border: "none !important",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: 0,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} mb={1.5}>
                <StandardLabel label={t("SIM IMEI / ICCID")} />
                <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: false }}
                  placeholder={t("Type SIM IMEI")}
                  value={formData.simCard?.simImei || ""}
                  onChange={(e) => handleInputChange(e, "simCard.simImei")}
                  error={!!errors.simImei}
                  helperText={errors.simImei}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "55px",
                      borderRadius: "16px",
                      padding: "16px 24px",
                      border: errors.simImei
                        ? "2px solid #d32f2f"
                        : "2px solid #183059",
                      "&:hover": {
                        border: errors.simImei
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "&.Mui-focused": {
                        border: errors.simImei
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "& fieldset": {
                        border: "none !important",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: 0,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} mb={1.5}>
                <StandardLabel label={t("Telecom Operator")} />
                <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: false }}
                  placeholder={t("Type Provider")}
                  value={formData.simCard?.provider || ""}
                  onChange={(e) => handleInputChange(e, "simCard.provider")}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "55px",
                      borderRadius: "16px",
                      padding: "16px 24px",
                      border: "2px solid #183059",
                      "&:hover": {
                        border: "2px solid #183059",
                      },
                      "&.Mui-focused": {
                        border: "2px solid #183059",
                      },
                      "& fieldset": {
                        border: "none !important",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: 0,
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} mb={1.5}>
                <StandardLabel label={t("SIM Activation Date")} />
                <TextField
                  fullWidth
                  type="date"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={formData.simCard?.simActivationDate || ""}
                  onChange={(e) =>
                    handleInputChange(e, "simCard.simActivationDate")
                  }
                  error={!!errors.simActivationDate}
                  helperText={errors.simActivationDate}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "55px",
                      borderRadius: "16px",
                      padding: "16px 24px",
                      border: errors.simActivationDate
                        ? "2px solid #d32f2f"
                        : "2px solid #183059",
                      "&:hover": {
                        border: errors.simActivationDate
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "&.Mui-focused": {
                        border: errors.simActivationDate
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "& fieldset": {
                        border: "none !important",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: 0,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} mb={1.5}>
                <StandardLabel label={t("Next Recharge Date")} />
                <TextField
                  fullWidth
                  type="date"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={formData.simCard?.nextRechargeDate || ""}
                  onChange={(e) =>
                    handleInputChange(e, "simCard.nextRechargeDate")
                  }
                  error={!!errors.nextRechargeDate}
                  helperText={errors.nextRechargeDate}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "55px",
                      borderRadius: "16px",
                      padding: "16px 24px",
                      border: errors.nextRechargeDate
                        ? "2px solid #d32f2f"
                        : "2px solid #183059",
                      "&:hover": {
                        border: errors.nextRechargeDate
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "&.Mui-focused": {
                        border: errors.nextRechargeDate
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "& fieldset": {
                        border: "none !important",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: 0,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} mb={1.5}>
                <StandardLabel label={t("Owner")} />
                <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: false }}
                  placeholder={t("Type Sim Owner")}
                  value={formData.simCard?.ownedBy || ""}
                  onChange={(e) => handleInputChange(e, "simCard.ownedBy")}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "55px",
                      borderRadius: "16px",
                      padding: "16px 24px",
                      border: "2px solid #183059",
                      "&:hover": {
                        border: "2px solid #183059",
                      },
                      "&.Mui-focused": {
                        border: "2px solid #183059",
                      },
                      "& fieldset": {
                        border: "none !important",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: 0,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} mb={1.5}>
                <StandardLabel label={t("Status")} />
                <Select
                  fullWidth
                  value={formData.simCard?.simStatus || "INACTIVE"}
                  onChange={(e) => handleInputChange(e, "simCard.simStatus")}
                  sx={{
                      height: "55px",
                      borderRadius: "16px",
                      padding: 0,
                      border: errors.simStatus
                        ? "2px solid #d32f2f"
                        : "2px solid #183059",
                      "&:hover": {
                        border: errors.simStatus
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "&.Mui-focused": {
                        border: errors.simStatus
                          ? "2px solid #d32f2f"
                          : "2px solid #183059",
                      },
                      "& fieldset": { border: "none" },
                      "& .MuiSelect-select": {
                        padding: "16px 24px",
                      },
                    }}
                >
                  <MenuItem value="INACTIVE">{t("Inactive")}</MenuItem>
                  <MenuItem value="ACTIVE">{t("Active")}</MenuItem>
                </Select>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
